<template>
  <div>
    <load-script
      v-if="shouldLoadScript"
      :src="getBazaarvoiceUrl"
      @loaded="scriptLoaded"
    />
    <slot v-if="loaded" />
    <slot
      v-if="onScreen && !loaded"
      name="loading"
    />
    <slot
      v-if="!onScreen"
      name="reviews"
    />
  </div>
</template>

<script>
  import { intersectionViewportObserver } from '@Foundation/utilities/intersectionViewportObserver';
  import LoadScript from '@Foundation/loadscript/loadscript';
  import { mapGetters } from 'vuex';

  export default {
    name: 'LazyloadingWrapper',
    components: {
      LoadScript
    },
    data() {
      return {
        onScreen: false,
        loaded: false
      };
    },
    computed: {
      ...mapGetters('bvStore', [
        'getBazaarvoiceUrl'
      ]),
      shouldLoadScript() {
        return this.getBazaarvoiceUrl && this.onScreen;
      }
    },
    mounted() {
      intersectionViewportObserver(this.$el, { checkIsVisible: true }).then(() => {
        this.onScreen = true;
      });
    },
    methods: {
      scriptLoaded() {
        this.loaded = true;
      }
    }
  };
</script>
